import api from "./api"

export const listEquipmentSigma = async (search) => {
  return await api.get(`/equipment-sigma${search ? `?search_text=${search}` : ""}`)
}

export const listAnalytesInEquipment = async (idEquipment) => {
  return await api.get(`equipment-sigma/${idEquipment}/analytes`)
}

export const updateAnalytesInEquipment = async (idEquipment, analyteId, biovar_nid) => {
  return await api.put(
    `/equipment-sigma/${idEquipment}/analytes/${analyteId}`,
    biovar_nid,
  )
}

export const postValueDRM = async (idEquipment, idAnalyte, eqpanltdrm_nvalue) => {
  return await api.post(`/equipment-sigma/${idEquipment}/analytes/${idAnalyte}/drm`, {
    eqpanltdrm_nvalue: eqpanltdrm_nvalue,
  })
}
export const updateValueDRM = async (
  idEquipment,
  idAnalyte,
  eqpanltdrm_nvalue,
  idDRM,
  reason,
) => {
  return await api.put(
    `/equipment-sigma/${idEquipment}/analytes/${idAnalyte}/drm/${idDRM}`,
    {
      eqpanltdrm_nvalue: eqpanltdrm_nvalue,
      eqpanltdrm_creason: reason,
    },
  )
}

export const deleteValueDRM = async (idEquipment, idAnalyte, idDRM, reason) => {
  return await api.delete(
    `/equipment-sigma/${idEquipment}/analytes/${idAnalyte}/drm/${idDRM}`,
    {
      data: {
        eqpanltdrm_creason: reason,
      },
    },
  )
}

export const listDRM = async (idEquipment, idAnalyte) => {
  return await api.get(`/equipment-sigma/${idEquipment}/analytes/${idAnalyte}/drm`)
}

export const analyteInEquipment = async (idEquipment, eqpAnltId) => {
  return await api.get(`/equipment/${idEquipment}/equipment-analyte/${eqpAnltId}`)
}

export const updateAnalyteInEquipment = async (idEquipment, eqpAnltId, data) => {
  return await api.put(
    `/equipment/${idEquipment}/equipment-analyte/${eqpAnltId}`,
    data,
  )
}
